// src/components/Showcase.js
import React from 'react';
import { Box, Typography, Card, CardContent, CardMedia, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Showcase = ({ items }) => {
  if (!items || items.length === 0) return null;

  const activeItem = items[0]; // only show the first event

  // Format date string
  const dateText = activeItem.endDate
    ? `${activeItem.startDate} - ${activeItem.endDate}`
    : activeItem.startDate;

  const dateLocationText = activeItem.location ? `${dateText}, ${activeItem.location}` : dateText;

  return (
    <Box component="section" sx={{ py: 6, textAlign: 'center' }}>
      {/* Title */}
      <Typography
        sx={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 400,
          fontSize: '32px',
          color: '#142434',
          mb: 4,
        }}
      >
        Showcase Event
      </Typography>

      {/* Event Card */}
      <Card
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          maxWidth: 900,
          width: '100%',
          border: '0.5px solid #489596',
          boxShadow: 'none',
          borderRadius: '8px',
          overflow: 'hidden',
          p: 3,
          mx: 'auto', // center horizontally
          flexWrap: { xs: 'wrap', md: 'nowrap' },
        }}
      >
        {/* Image */}
        {activeItem.image ? (
          <MuiLink
            component={RouterLink}
            to={activeItem.link || '#'}
            sx={{ display: 'block', width: 244, height: 244, flexShrink: 0, mr: { md: 3 }, mb: { xs: 2, md: 0 } }}
          >
            <CardMedia
              component="img"
              image={activeItem.image}
              alt={activeItem.title}
              sx={{ width: 244, height: 244, objectFit: 'cover', display: 'block' }}
            />
          </MuiLink>
        ) : (
          <Box sx={{ width: 244, height: 244, backgroundColor: '#f0f0f0', flexShrink: 0, mr: { md: 3 }, mb: { xs: 2, md: 0 } }} />
        )}

        {/* Text */}
        <CardContent sx={{ textAlign: 'left', p: 0 }}>
          {/* Title */}
          <MuiLink
            component={RouterLink}
            to={activeItem.link || '#'}
            underline="none"
            sx={{ textDecoration: 'none', display: 'inline-block', mb: 1 }}
          >
            <Typography
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 400,
                fontSize: '24px',
                color: '#489596',
                mb: 1,
              }}
            >
              {activeItem.title}
            </Typography>
          </MuiLink>

          {/* Date & Location */}
          {dateLocationText && (
            <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '14px', color: '#142434', mb: 0.5, textTransform: 'uppercase', }}>
              {dateLocationText}
            </Typography>
          )}

          {/* Event Type */}
          {activeItem.eventType && (
            <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '14px', color: '#142434', mb: 1, textTransform: 'uppercase', }}>
              {activeItem.eventType}
            </Typography>
          )}

          {/* Description */}
          <Typography sx={{ fontFamily: 'PT Sans, sans-serif', fontSize: '16px', lineHeight: 1.5, color: '#142434' }}>
            {activeItem.description}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Showcase;
